/**
 * Adds "All Categories link" in breadcrumb[]
 * @param {Object[]} breadCrumbs Array of objects
 * @param {Object} allCategoriesLink Object of breadcrumb link
 * @returns Array of object
 */
export const getUpdatedBreadcrumbs = (breadCrumbs, allCategoriesLink) => {
  if (!breadCrumbs) {
    return [];
  }
  if (!allCategoriesLink) {
    return breadCrumbs;
  }

  const [firstLink, ...otherLinks] = breadCrumbs;
  return breadCrumbs.length
    ? [firstLink, allCategoriesLink, ...otherLinks]
    : breadCrumbs;
};
